export const socialmedia = {
    facebook: "https://www.facebook.com/profile.php?id=100064279564055&sk=about",
    linkedIn: "https://www.linkedin.com/company/cable-solutions-kft-/about/"
  };

